import styled from 'styled-components'

const MenuStyle = styled.div`
  background-color: #fff;
  font-family: 'Ubuntu-Light';
  font-size: 16px;
  border-radius: 3px;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 24px 0;

  .item {
    padding-left: 24px;
  }

  .active {
    border-left: 5px solid ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.primary.main};
    padding-left: 19px;
  }

  .sublevel {
    display: flex;
    font-size: 14px;
    padding-left: 16px;
    width: 100%;
    align-items: center;
    height: 24px;
  }

  .primary-level {
    display: flex;
    justify-content: space-between;
  }

  .primary-level-text {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 24px;
  }

  .errorCount {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #a8001b;
    color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    position: absolute;
    margin-left: 250px;
  }

  .errorCount p {
    font-family: 'Ubuntu';
    font-size: 11x;
  }
`
export default MenuStyle
